import { Grid, Typography } from "@mui/material";
import type { FC } from "react";
import type { Control } from "react-hook-form";
import { Controller } from "react-hook-form";
import FormHtmlEdit from "../../components/formComponents/FormHtmlEdit";
import FormNumberField from "../../components/formComponents/FormNumberField";
import FormTextField from "../../components/formComponents/FormTextField";
import ImagesPicker from "../../components/imagesPicker/ImagesPicker";
import { useImages } from "../../media/useImages";
import type { ImageFlavour } from "../../publicPackages/publicPackagesApi";

interface RewardImage {
  readonly id: string;
  readonly name: string;
  readonly thumbnail: { url: string };
  readonly original: { url: string };
  readonly www: { readonly url: string };
  readonly flavours: Partial<Record<ImageFlavour, { readonly url: string }>>;
}

export interface Reward {
  name: string;
  description: string;
  cost: number;
  image?: RewardImage | null;
}

interface Props {
  readonly control: Control<Reward>;
  readonly errors: string[];
}

const RewardEdit: FC<Props> = ({ control, errors }) => {
  const { images, isLoading } = useImages();
  return (
    <Grid size={12} container spacing={2}>
      <Grid size={{ xs: 12, lg: 6 }}>
        <FormTextField
          label="Nazwa"
          name="name"
          autoFocus
          control={control}
          rules={{ required: { value: true, message: "Nazwa nie może być pusta" } }}
        />
      </Grid>
      <Grid size={{ xs: 12, lg: 6 }}>
        <FormNumberField
          label="Koszt"
          name="cost"
          control={control}
          min={1}
          rules={{ min: { value: 1, message: "Koszt musi być dodatni" } }}
        />
      </Grid>
      <Grid size={{ xs: 12, lg: 6 }}>
        <FormHtmlEdit name="description" control={control} />
      </Grid>
      <Grid size={{ xs: 12, md: 10, lg: 6 }}>
        <Controller
          name="image"
          control={control}
          render={({ field: { onChange, value } }) => (
            <ImagesPicker
              label="Zdjęcie"
              limit={1}
              images={images}
              isLoading={isLoading}
              selectedImages={value ? [value] : []}
              onSelectionChange={(images) => onChange(images[0])}
            />
          )}
        />
      </Grid>
      <Grid size={12}>
        {errors.length > 0 && (
          <Typography variant="body2" color="error">
            Błąd:
          </Typography>
        )}
      </Grid>
    </Grid>
  );
};
export default RewardEdit;
